// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgBellXmarkNotification = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M15.111 9.166c.485 4.48 2.389 5.833 2.389 5.833h-15S5 13.222 5 7c0-1.414.527-2.77 1.464-3.77.938-1.001 2.21-1.563 3.536-1.563q.423 0 .833.075m.609 15.758a1.666 1.666 0 0 1-2.883 0m4.941-11L15.993 4M18.5 1.5 15.993 4m0 0L13.5 1.5M15.993 4 18.5 6.5" />
    </g>
  </svg>
);
export const BellXmarkNotificationIcon = forwardRef(SvgBellXmarkNotification);
